module.exports = __webpack_public_path__ + "img/attraction-2-old.5f358c8a.jpg";